import EditIcon from '@mui/icons-material/Edit';
import { IconButton, IconButtonProps, Tooltip, TooltipProps as MuiTooltipProps } from '@mui/material';

interface IEditButtonProps extends IconButtonProps {
  TooltipProps?: Partial<MuiTooltipProps> & Pick<MuiTooltipProps, 'title'>;
}

function EditButton({ TooltipProps, ...props }: IEditButtonProps) {
  const button = (
    <IconButton {...props}>
      <EditIcon />
    </IconButton>
  );

  return TooltipProps?.title ? <Tooltip {...TooltipProps}>{button}</Tooltip> : button;
}
export default EditButton;
